import axios from 'axios'

import { Config, Header as HeaderPlain } from '../../config.api'

const Header = async () => {
  const header = await HeaderPlain()
  header.headers['by-pass'] = true
  return header
}

const GetJettyEnum = async () => {
  try {
    const response = await axios.get(
      `${Config.MAIN_SERVICE_ENDPOINT}/enums?skip=0&take=1000&filter=[{"type":"text","field":"type","value":"Jetty_Maps"}]`,
      await Header()
    )
    return response.data
  } catch (error) {
    return error
  }
}

const GetOnProgress = async (filter, search) => {
  try {
    const response = await axios.get(
      `${Config.MAIN_SERVICE_ENDPOINT}/jetty_maps?filter=${filter}&search=${search}`,
      await Header()
    )
    return response.data
  } catch (error) {
    return error
  }
}

const GetNextComing = async (filter) => {
  try {
    const response = await axios.get(
      `${Config.MAIN_SERVICE_ENDPOINT}/jetty_maps_nextcoming?filter=${filter}`,
      await Header()
    )
    return response.data
  } catch (error) {
    return error
  }
}

const GetActivity = async (queryParams) => {
  try {
    const response = await axios.get(
      `${Config.MAIN_SERVICE_ENDPOINT}/progress_activities?${queryParams}`,
      await Header()
    )
    return response.data
  } catch (error) {
    return error
  }
}

const GetDelay = async (srNo) => {
  try {
    const response = await axios.get(
      `${Config.MAIN_SERVICE_ENDPOINT}/progress_delays?skip=0&take=1000&filter=[{"type":"text","field":"sr_no","value":"${srNo}"}]&sort=id|desc`,
      await Header()
    )
    return response.data
  } catch (error) {
    return error
  }
}

const GetIntervalDataJetty = async (skip, take, filters) => {
  try {
    const response = await axios.get(
      `${Config.MAIN_SERVICE_ENDPOINT}/enums?skip=${skip}&take=${take}&filter=${filters}`,
      await Header()
    )
    return response.data
  } catch (error) {
    return error
  }
}

const GetMapsJettyLocation = async (skip, take, filters) => {
  try {
    const response = await axios.get(
      `${Config.MAIN_SERVICE_ENDPOINT}/enums?skip=${skip}&take=${take}&filter=${filters}`,
      await Header()
    )
    return response.data
  } catch (error) {
    return error
  }
}

const UpdateCraneBargePosition = async (data) => {
  try {
    const response = await axios.post(
      `${Config.MAIN_SERVICE_ENDPOINT}/new/progress-task`,
      {
        action: 'UPDATE_PROGRESS_TASK_DETAIL_POSITION',
        task_detail_datas: data
      },
      await Header()
    )
    return response.data
  } catch (error) {
    return error
  }
}

export default {
  GetDelay,
  GetActivity,
  GetJettyEnum,
  GetOnProgress,
  GetNextComing,
  GetIntervalDataJetty,
  GetMapsJettyLocation,
  UpdateCraneBargePosition
}
